<template>
  <mv-page>
    <v-flex slot="header" xs12 hidden-sm-and-down>
    </v-flex>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 lg4>
          <h2 class="font-weight-light">Регистрация</h2>
          <v-form ref="form">
            <v-text-field
              required outline
              type="email"
              name="email" :disabled="locked"
              ref="iemail"
              v-model="email"
              label="адрес электронной почты"
              append-icon="email"
              hint="на этот адрес вы получите письмо для подтверждения регистрации"
              @keyup.enter="$refs.ifamily.focus"
            ></v-text-field>
            <v-text-field required outline type="text"
              name="family" :disabled="locked"
              ref="ifamily"
              v-model="family"
              label="фамилия ученика"
              append-icon="star"
              @keyup.enter="$refs.iname.focus"
            ></v-text-field>
            <v-text-field required outline type="text"
              name="name" :disabled="locked"
              ref="iname"
              v-model="name"
              label="имя ученика"
              append-icon="star"
              @keyup.enter="$refs.ipassword.focus"
            ></v-text-field>
            <v-text-field required outline type="text"
              name="login" :disabled="locked"
              v-model="cardid"
              label="школьная карта"
              append-icon="credit_card"
              hint="6-9 цифр"
              @keyup.enter="$refs.iemail.focus"
            ></v-text-field>
            <v-text-field required outline type="password"
              name="password" :disabled="locked"
              ref="ipassword"
              v-model="password"
              label="пароль"
              append-icon="lock"
              @keyup.enter="$refs.ipassword2.focus"
            ></v-text-field>
            <v-text-field required outline type="password"
              name="password2" :disabled="locked"
              ref="ipassword2"
              v-model="password2"
              label="пароль (ещё раз)"
              append-icon="lock"
            ></v-text-field>
            <v-alert
               :value="issue"
               type="warning"
             >
               {{issue}}
             </v-alert>
            <v-checkbox label=""
              v-model="accept2" :disabled="locked"
            >
              <span slot="label">
                Условия договора-оферты на использование системы безналичной оплаты школьного питания прочитал и принимаю
              </span>
            </v-checkbox>
            <v-checkbox label="Даю согласие МБУ «ЦДС ГПТ» на обработку персональных данных"
            v-model="accept1" :disabled="locked"
            ></v-checkbox>
            <br>
            <v-btn outline block large color="primary" @click.native.stop="signup" :disabled="locked || issue !== null">
              Продолжить
            </v-btn>
          </v-form>
        </v-flex>
        <v-flex d-flex sm12 md1></v-flex>
        <v-flex sm12 md7 lg7 d-flex>
          <v-card light color="blue lighten-5" class="mb-1">
            <v-card-text>
              <p>Если вы ранее регистрировались на сайте, то перейдите на <a href="/#/login">страницу входа</a>.</p>
              <p>
                С условиями договора-оферты на использование системы безналичной оплаты школьного питания вы можете ознакомиться
                <a href="https://cds43.ru/storage/documents/1721217537_%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%20%D0%BE%D1%84%D0%B5%D1%80%D1%82%D1%8B%2017-07-2024.pdf" target="__blank">по ссылке</a>
              </p>
              <p>С соглашением о замене стороны по договору (публичная оферта) от 30.09.2021 можете ознакомиться
                <a href="https://cds43.ru/storage/documents/1632997843_%20%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%20%D0%B7%D0%B0%D0%BC%D0%B5%D0%BD%D0%B5%20%D1%81%D1%82%D0%BE%D1%80%D0%BE%D0%BD%D1%8B%20%D0%BF%D0%BE%20%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D1%83%20(%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D1%87%D0%BD%D0%B0%D1%8F%20%D0%BE%D1%84%D0%B5%D1%80%D1%82%D0%B0)%20%D0%BE%D1%82%2030.09.2021.pdf" target="_blank"> по ссылке</a>
              </p>
              <p>С политикой обработки данных клиентов можно ознакомится по
                <a href="https://cds43.ru/storage/documents/1693900991_Prilozhenie_N2_Politika_obrabotki_PNd_klientov-polzovateley_elektronnyh_kart_v_MBU_CDS_GPT.pdf" target="_blank">ссылке</a></p>
              <v-card flat style="max-height: 700px; overflow-y: scroll">
                <contract-offer></contract-offer>
              </v-card>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>
<script>
import ContractOffer from '@/components/ContractOffer.vue'
/* eslint-disable-next-line no-useless-escape */
const emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export default {
  name: 'login',
  components: {
    ContractOffer
  },
  data: () => ({
    cardid: null,
    email: null,
    family: null,
    name: null,
    password: null,
    password2: null,
    accept1: false,
    accept2: false,
    locked: false,
  }),
  computed: {
    cardidFormatted () {
      if (!this.cardid) return null
      return ('000' + this.cardid).slice(-9)
    },
    emailFormatted () {
      if (!this.email) return null
      return this.email.trim()
    },
    familyFormatted () {
      if (!this.family) return null
      const fam = this.family.split(/\s/).join('').toLowerCase()
      return fam.charAt(0).toUpperCase() + fam.slice(1)
    },
    nameFormatted () {
      if (!this.name) return null
      const nam = this.name.split(/\s/).join('').toLowerCase()
      return nam.charAt(0).toUpperCase() + nam.slice(1)
    },
    issue () {
      if (!this.cardid) return 'Карта - обязательное поле'
      if (!/^\d{9}$/g.test(this.cardidFormatted)) return 'Карта должна состоять из 6-9 цифр'
      if (!this.email) return 'Адрес электронной почты - обязательное поле'
      if (!emailRe.test(this.emailFormatted)) return 'Некорректный адрес электронной почты'
      if (!this.family) return 'Фамилия - обязательное поле'
      if (!/^[А-ЯЁ-]{1}[а-яё-]{0,49}$/.test(this.familyFormatted)) return 'Фамилия должна состоять из кириллических символов'
      if (!this.name) return 'Имя - обязательное поле'
      if (!/^[А-ЯЁ]{1}[а-яё]{0,49}$/.test(this.nameFormatted)) return 'Имя должно состоять из кириллических символов'
      if (!this.password) return 'Пароль - обязательное поле'
      if (this.password.length < 5) return 'Пароль слишком короткий'
      if (this.password.length > 16) return 'Пароль слишком длинный'
      if (/^\d+$/g.test(this.password)) return 'Пароль слишком простой'
      if (this.password !== this.password2) return 'Пароли не совпадают'
      if (!this.accept1) return 'Нужно дать согласие на обработку данных'
      if (!this.accept2) return 'Нужно подвердить согласие с договором'
      return null
    }
  },
  methods: {
    async signup () {
      if (this.issue) return
      try {
        this.locked = true
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'registrations-create-request',
          pl: {
            cardid: this.cardidFormatted,
            address: this.emailFormatted,
            family: this.familyFormatted,
            name: this.nameFormatted,
            password: this.password
          }
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
        this.locked = false
      }
    }
  },
  watch: {
    familyFormatted (val) {
      if (val) this.family = val
    },
    nameFormatted (val) {
      if (val) this.name = val
    }
  },
  mounted () {
    localStorage.removeItem('detiPapiToken')
  }
}
</script>
